import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
// Toast
import { useToast } from "../../../../hooks/toast";
import { hearingTypeAttendantRole } from "../../../../services/hearingTypeAttendantRole";
import { LogOperation } from "../../../../utils/entities/logOperation";
// Assets
import CheckBoxLabel from "components/CheckBoxLabel";

import {
  Container,
  ContainerBody,
  ContainerInputs,
} from "../../StyleCSS/bodyCreateEdit";
import { IDefaultObject, IHearingTypeAttendantRoleItem } from "../index";
import { IResultCheckBox } from "../../../../components/CheckBoxGlobal";
import { ContentCheckbox } from "../styles";

interface ICreateEditHearingTypeAttendantRole {
  isEdit: boolean;
  postOrPutTrue: boolean;
  setPostOrPutTrue: (e: boolean) => unknown;
  hearingTypeList: Array<IDefaultObject>;
  attendantRoleList: Array<IDefaultObject>;
  hearingTypeAttendantRoleItem?: IHearingTypeAttendantRoleItem;
  closeModal: boolean;
  hearingTypeId: any;
  setCloseModal: (e: boolean) => unknown;
}

export const CreateEditProcedureCustomerAttendantRole = (
  props: ICreateEditHearingTypeAttendantRole
): JSX.Element => {
  const { t } = useTranslation();
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const { addToast } = useToast();

  const [listToShow, setListToShow] = useState<IResultCheckBox[]>([]);
  const [newListChecks, setNewListChecks] = useState<IResultCheckBox[]>([]);

  const relationshipOriginalList =
    props.hearingTypeAttendantRoleItem?.attendantRoleList ?? [];
  let listIdsToDelete: number[] = [];
  let listIdsToAdd: number[] = [];

  useEffect(() => {
    setIsLoad(true);
    if (props.isEdit) {
      setListToShow(
        convertTypeList(
          props.hearingTypeAttendantRoleItem?.attendantRoleList ?? [],
          false
        )
      );
    }
    setIsLoad(false);
  }, []);

  useEffect(() => {
    if (props.postOrPutTrue) {
      putUpdate();
      props.setPostOrPutTrue(false);
    }
  }, [props.postOrPutTrue]);

  useEffect(() => {
    props.setCloseModal(true);
  }, [props.closeModal]);

  function validationFields() {
    if (listIdsToDelete.length === 0 && listIdsToAdd.length === 0) {
      addToast({
        type: "warning",
        title: t("audiences.hearingTypeLink.linkTitle"),
        description: t("audiences.hearingTypeLink.updateRequired"),
      });
      return false;
    }
    return true;
  }

  async function putUpdate() {
    try {
      choiseAction();
      if (!validationFields()) return;
      // ADD
      for (const id of listIdsToAdd) {
        await hearingTypeAttendantRole.vincularHearingTypeEAttendantRole(
          LogOperation.getCustomerId(),
          props.hearingTypeId,
          id
        );
      }
      // DELETE
      for (const id of listIdsToDelete) {
        await hearingTypeAttendantRole.deletarVinculoHearingTypeEAttendantRole(
          id
        );
      }
      addToast({
        type: "success",
        title: t("audiences.hearingTypeLink.linkTitle"),
        description: t("audiences.hearingTypeLink.updateSuccess"),
      });
      listIdsToDelete = [];
      listIdsToAdd = [];
      props.setCloseModal(false);
    } catch {
      addToast({
        type: "warning",
        title: t("audiences.hearingTypeLink.linkTitle"),
        description: t("audiences.hearingTypeLink.createRequired"),
      });
    }
  }

  function convertTypeList(
    arrayAttendant: IDefaultObject[],
    disabled: boolean
  ): IResultCheckBox[] {
    return props.attendantRoleList.map((item) => ({
      id: item.attendantRoleId,
      label: item.name,
      isChecked: arrayAttendant.some((x) => x.id === item.attendantRoleId),
      disabled:
        disabled &&
        arrayAttendant.some((x) => x.id === item.attendantRoleId),
    }));
  }

  function choiseAction() {
    for (const element of newListChecks) {
      const existedBefore = relationshipOriginalList.some(
        (x) => x.id === element.id
      );
      if (element.isChecked && !existedBefore) {
        listIdsToAdd.push(element.id);
      }
      if (!element.isChecked && existedBefore) {
        const toDelete = relationshipOriginalList.find(
          (x) => x.id === element.id
        );
        if (toDelete?.hearingTypeAttendantRoleId) {
          listIdsToDelete.push(toDelete.hearingTypeAttendantRoleId);
        }
      }
    }
  }

  function handleToggle(id: number) {
    const updated = listToShow.map((item) =>
      item.id === id ? { ...item, isChecked: !item.isChecked } : item
    );
    setListToShow(updated);
    setNewListChecks(updated);
  }

  return (
    <>
      {!isLoad && (
        <Container>
          <ContainerBody>
            <ContainerInputs>
              <h2>{props.hearingTypeAttendantRoleItem?.hearingTypeName}</h2>
            </ContainerInputs>

            <ContentCheckbox>
              {listToShow.map((item) => (
                <CheckBoxLabel
                  key={item.id}
                  id={`checkbox-${item.id}`}
                  label={item.label}
                  checked={item.isChecked}
                  disabled={item.disabled}
                  onChange={() => handleToggle(item.id)}
                />
              ))}
            </ContentCheckbox>
          </ContainerBody>
        </Container>
      )}
    </>
  );
};
